exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/hq/hq-template/hq-template.component.css
// module id = ../../../../../src/app/hq/hq-template/hq-template.component.css
// module chunks = main